/* MAEN – Announcement bar (sections/maen-announcement.liquid)
   1. Review line: Yotpo bottomline (product + shop reviews, like the reviews page), cached for the visit.
   2. Messages: fade in turn; pause while hovered/focused; theme editor shows the selected block. */
(function () {
  if (customElements.get('maen-announcement')) return;

  var CACHE_KEY = 'maenAnnReviews';
  var CACHE_MS = 6 * 60 * 60 * 1000;
  // 2026-10-24 (Jules): the last live figure this browser saw is kept (localStorage, no expiry) and shown while
  // Yotpo can't be reached; it is never cached as fresh, so the next page view asks Yotpo again
  var LAST_KEY = 'maenReviewsLast';

  function loadReviews(key) {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.key === key && Date.now() - c.t < CACHE_MS) return Promise.resolve(c);
    } catch (e) {}
    var base = 'https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(key);
    var get = function (url) {
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('Yotpo ' + r.status);
        return r.json();
      }).then(function (j) { return j.response.bottomline; });
    };
    return Promise.all([
      get(base + '/reviews.json?per_page=1'),
      get(base + '/products/yotpo_site_reviews/reviews.json?per_page=1'),
    ]).then(function (b) {
      var total = b[0].total_review + b[1].total_review;
      if (!total) throw new Error('no reviews');
      var avg = (b[0].average_score * b[0].total_review + b[1].average_score * b[1].total_review) / total;
      var data = { key: key, total: total, avg: avg, t: Date.now() };
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch (e) {}
      try { localStorage.setItem(LAST_KEY, JSON.stringify(data)); } catch (e) {}
      return data;
    }).catch(function (err) {
      try {
        var last = JSON.parse(localStorage.getItem(LAST_KEY) || 'null');
        if (last && last.key === key && last.total) return last;
      } catch (e) {}
      throw err;
    });
  }

  customElements.define('maen-announcement', class extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-maen-ann-message]'));
      this.index = Math.max(0, this.messages.findIndex(function (m) { return m.classList.contains('is-active'); }));
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.paused = false;

      this.initReviews();

      if (this.messages.length > 1) {
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });
        this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.show(this.index + 1); }, this.interval);
      }

      if (window.Shopify && Shopify.designMode) {
        this.onSelect = (e) => {
          var i = this.messages.findIndex(function (m) { return m.dataset.blockId === e.detail.blockId; });
          if (i > -1) { this.paused = true; this.show(i); }
        };
        this.onDeselect = () => { this.paused = false; };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.onSelect) {
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }
    }

    show(i) {
      if (!this.messages.length) return;
      i = (i + this.messages.length) % this.messages.length;
      this.messages.forEach(function (m, n) {
        m.classList.toggle('is-active', n === i);
        if (n === i) m.removeAttribute('aria-hidden'); else m.setAttribute('aria-hidden', 'true');
      });
      this.index = i;
    }

    initReviews() {
      var el = this.querySelector('[data-maen-ann-reviews]');
      if (!el) return;
      loadReviews(el.dataset.appKey).then(function (d) {
        var round = parseInt(el.dataset.round, 10) || 1;
        var count = (Math.floor(d.total / round) * round).toLocaleString('en-US');
        var fill = function (t) { return (t || '').replace(/\[count\]/g, count); };
        el.querySelector('[data-maen-ann-score]').textContent = d.avg.toFixed(1);
        el.querySelector('[data-maen-ann-fill]').style.width = Math.min(100, (d.avg / 5) * 100) + '%';
        el.querySelector('[data-maen-ann-text]').textContent = fill(el.dataset.text);
        el.querySelector('[data-maen-ann-text-mobile]').textContent = fill(el.dataset.textMobile);
        el.setAttribute('aria-label', d.avg.toFixed(1) + ' out of 5 stars, ' + fill(el.dataset.text));
        el.classList.add('is-ready');
      }).catch(function () { /* Yotpo unreachable and no last figure in this browser: the review line stays hidden */ });
    }
  });
})();
